import cx from 'clsx';
import * as React from 'react';

import styles from './Infinite.module.scss';

export const prepareInfiniteChildrenArray = (children: React.ReactNode[]) => {
  const childrenAmount = children.length;
  const lastShownChildrenIndex =
    children.length -
    1 -
    (children.reverse().findIndex((el: any) => !el.props.hidden) || 0);
  const firstShownChildrenIndex =
    children.reverse().findIndex((el: any) => !el.props.hidden) || 0;
  return (childrenAmount > 1
    ? [...children, ...children, ...children]
    : children
  )
    .map((child: any, index: number) => {
      let shouldBeHidden = child && child.props && child.props.hidden === true;
      if (index < childrenAmount && index !== lastShownChildrenIndex)
        shouldBeHidden = true;
      if (
        index >= childrenAmount * 2 &&
        index !== firstShownChildrenIndex + 2 * childrenAmount
      )
        shouldBeHidden = true;

      return (
        <li
          data-testid="infinite-list-item"
          className={cx(
            styles.element,
            styles.infiniteSlideWrapper,
            shouldBeHidden && styles.none
          )}
          key={index}
        >
          {child}
        </li>
      );
    })
    .reduce(
      (
        acc: any,
        item: React.ReactElement,
        idx: number,
        items: React.ReactElement[]
      ) => {
        if (
          (idx < childrenAmount || idx >= childrenAmount * 2) &&
          childrenAmount > 1
        ) {
          const clone = items[idx];
          const modifiedClone = {
            ...clone,
            props: {
              ...clone.props,
              children: {
                ...clone.props.children,
                props: {
                  ...clone.props.children.props,
                  cloned: true,
                },
              },
            },
          };
          acc.push(
            React.cloneElement(modifiedClone, {
              key: `${item.key}_clone`,
            })
          );
        } else {
          acc.push(item);
        }
        return acc;
      },
      []
    );
};
